import { useYearPeriodStore } from '../../store/useYearPeriodStore'
import { Spinner } from '@heroui/react'
import { StationPanelLinePhoto } from '../panels/StationPanelLinePhoto'
import { YearPeriodPicker } from './shared/YearPeriodPicker'
import { MlyGrid } from './shared/MlyGrid'
import { TableOrientationToggle } from './shared/TableOrientationToggle'
import { withShortLabels } from './shared/rowGroupsTransposed'
import { useTableOrientationStore } from '../../store/useTableOrientationStore'
import { useMonthlyData } from '../../hooks/useMonthlyData'
import { useMonthlyNormals } from '../../hooks/useMonthlyNormals'

const SLUG = 'mly-vlhkost'

const ROW_GROUPS = [
  {
    label: 'Relativní vlhkost',
    rows: [
      { tsId: 'HUMIDITYAVG_AVG', label: 'Průměrná rel. vlhkost',   unit: '%', normalMode: 'diff', decimals: 1 },
      { tsId: 'HUMIDITYAVG_MAX', label: 'Maximum rel. vlhkosti',    unit: '%', normalMode: null,   decimals: 1 },
      { tsId: 'HUMIDITYAVG_MIN', label: 'Minimum rel. vlhkosti',    unit: '%', normalMode: null,   decimals: 1 },
    ],
  },
  {
    label: 'Tlak vodních par',
    rows: [
      { tsId: 'VAPPRESSAVG_AVG', label: 'Průměrný tlak vodních par', unit: 'hPa', normalMode: 'diff', decimals: 1 },
      { tsId: 'VAPPRESSAVG_MAX', label: 'Maximum tlaku vodních par',  unit: 'hPa', normalMode: null,   decimals: 1 },
      { tsId: 'VAPPRESSAVG_MIN', label: 'Minimum tlaku vodních par',  unit: 'hPa', normalMode: null,   decimals: 1 },
    ],
  },
  {
    label: 'Sytostní deficit',
    rows: [
      { tsId: 'SATURATIONAVG_AVG', label: 'Průměrný sytostní deficit', unit: 'hPa', normalMode: 'diff', decimals: 1 },
      { tsId: 'SATURATIONAVG_MAX', label: 'Maximum sytostního deficitu',unit: 'hPa', normalMode: null,   decimals: 1 },
      { tsId: 'SATURATIONAVG_MIN', label: 'Minimum sytostního deficitu',unit: 'hPa', normalMode: null,   decimals: 1 },
    ],
  },
]

// 2. definice hlavičky – transponovaná tabulka.
const ROW_GROUPS_T = withShortLabels(ROW_GROUPS, {
  HUMIDITYAVG_AVG: 'Průměr', HUMIDITYAVG_MAX: 'Maximum', HUMIDITYAVG_MIN: 'Minimum',
  VAPPRESSAVG_AVG: 'Průměr', VAPPRESSAVG_MAX: 'Maximum', VAPPRESSAVG_MIN: 'Minimum',
  SATURATIONAVG_AVG: 'Průměr', SATURATIONAVG_MAX: 'Maximum', SATURATIONAVG_MIN: 'Minimum',
})

const TS_IDS = ROW_GROUPS.flatMap(g => g.rows.map(r => r.tsId))

export function MlyVlhkostView({ station }) {
  const { year, setYear } = useYearPeriodStore()
  const orientation = useTableOrientationStore((s) => s.getOrientation(SLUG))

  const { dataMap, yearMap, dtMap, yearDtMap, isLoading: dLoading, isError: dError } = useMonthlyData(station?.gh_id, year, TS_IDS)
  const { normalsMap, yearNormalsMap, isLoading: nLoading }        = useMonthlyNormals(station?.gh_id, TS_IDS)

  const isLoading = dLoading || nLoading

  return (
    <div className="flex flex-col h-full">
      <div className="p-4 border-b border-gray-200 bg-white flex flex-col gap-3">
        {station && <StationPanelLinePhoto station={station} />}
        <div className="flex items-center justify-between gap-3">
          <YearPeriodPicker year={year} onYearChange={setYear} obsType="DLY" />
          <TableOrientationToggle slug={SLUG} />
        </div>
      </div>
      <div className="flex-1 min-h-0 p-4 flex flex-col">
        {isLoading && <div className="flex items-center gap-2 text-sm text-gray-500"><Spinner size="sm" /> Načítání dat…</div>}
        {dError && <p className="text-red-500 text-sm">Chyba při načítání dat</p>}
        {!isLoading && !dError && (
          <MlyGrid
            rowGroups={ROW_GROUPS}
            rowGroupsTransposed={ROW_GROUPS_T}
            orientation={orientation}
            dataMap={dataMap}
            yearMap={yearMap}
            dtMap={dtMap}
            yearDtMap={yearDtMap}
            normalsMap={normalsMap}
            yearNormalsMap={yearNormalsMap}
          />
        )}
      </div>
    </div>
  )
}
